import React, { useState, useContext, useEffect } from "react";
import "./IncomeConfigurator.scss";
import { INCOME_PARAMS } from "../../lib/calculator";
import { I18nContext } from "../../context";
import Input from "../Input/Input";

const MAX_DIGITS = 10;

/**
 * Income configuration form
 * @param {Object} props
 * @param {Object} props.income Data entered
 * @param {Function} props.setIncome Save new data on submit
 * @returns {React.ReactElement}
 */
function IncomeConfigurator({ income, setIncome }) {
  const { locale } = useContext(I18nContext);
  const [isExact, setIsExact] = useState(false);

  const onSubmit = (event) => {
    event.preventDefault();

    const data = new FormData(event.target);
    const newIncome = {};

    for (const [key, value] of data.entries()) {
      const number = parseInt(value || 0, 10);

      newIncome[key] = Math.max(0, number);
    }

    setIncome(newIncome);
  };

  const fields = INCOME_PARAMS.map((param, i) => ({
    name: param,
    label: locale[`${param}Label`],
    help: locale[`${param}Help`],
    value: income[param],
    prefix: locale.currency,
    required: i === 0,
    // Limit digits
    onInput: (event) => {
      const { value } = event.target;

      if (value.length > MAX_DIGITS) {
        event.target.value = value.slice(0, MAX_DIGITS);
      }
    },
    isExact: i > 0,
  }));

  // Show detailed form if we have pre-filled "exact" fields
  useEffect(() => {
    if (fields.find((field) => field.isExact && field.value)) {
      setIsExact(true);
    }
  }, [fields]);

  return (
    <div className="IncomeConfigurator">
      <div className="IncomeConfigurator__inner">
        <div className="IncomeConfigurator__lead">
          <h1
            className="IncomeConfigurator__title"
            dangerouslySetInnerHTML={{ __html: locale.mainTitle }}
          />
          <p className="IncomeConfigurator__text">{locale.mainSubtitle}</p>
        </div>
        <form className="IncomeConfigurator__form" onSubmit={onSubmit}>
          <div className="IncomeConfigurator__form-inner">
            <ul className="IncomeConfigurator__items">
              {fields.map((field) =>
                !field.isExact || isExact ? (
                  <li className="IncomeConfigurator__item" key={field.name}>
                    <Input {...field} />
                  </li>
                ) : null
              )}
            </ul>
            <button
              className="IncomeConfigurator__toggle"
              type="button"
              onClick={() => setIsExact(!isExact)}
            >
              {isExact ? locale.lessInputLabel : locale.moreInputLabel}
            </button>
          </div>
          <button className="IncomeConfigurator__submit" type="submit">
            {locale.startButtonLabel}
          </button>
        </form>
      </div>
    </div>
  );
}

export default IncomeConfigurator;
